/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */

import React from 'react';
import Figure from '../Figure';
import FigCaption from '../FigCaption';
import FigContainer from '../FigContainer';
import CategoryHeader from '../CategoryHeader';

/* eslint-disable prettier/prettier */
import Icon3DRotation from '../../../../../../Icon/Icon3DRotation';
import IconAccessibility from '../../../../../../Icon/IconAccessibility';
import IconAccessible from '../../../../../../Icon/IconAccessible';
import IconAccountBalance from '../../../../../../Icon/IconAccountBalance';
import IconAccountBalanceWallet from '../../../../../../Icon/IconAccountBalanceWallet';
import IconAccountBox from '../../../../../../Icon/IconAccountBox';
import IconAccountCircle from '../../../../../../Icon/IconAccountCircle';
import IconAddShoppingCart from '../../../../../../Icon/IconAddShoppingCart';
import IconAlarm from '../../../../../../Icon/IconAlarm';
import IconAlarmAdd from '../../../../../../Icon/IconAlarmAdd';
import IconAlarmOff from '../../../../../../Icon/IconAlarmOff';
import IconAlarmOn from '../../../../../../Icon/IconAlarmOn';
import IconAllOut from '../../../../../../Icon/IconAllOut';
import IconAndroid from '../../../../../../Icon/IconAndroid';
import IconAnnouncement from '../../../../../../Icon/IconAnnouncement';
import IconAspectRatio from '../../../../../../Icon/IconAspectRatio';
import IconAssessment from '../../../../../../Icon/IconAssessment';
import IconAssignment from '../../../../../../Icon/IconAssignment';
import IconAssignmentInd from '../../../../../../Icon/IconAssignmentInd';
import IconAssignmentLate from '../../../../../../Icon/IconAssignmentLate';
import IconAssignmentReturn from '../../../../../../Icon/IconAssignmentReturn';
import IconAssignmentReturned from '../../../../../../Icon/IconAssignmentReturned';
import IconAssignmentTurnedIn from '../../../../../../Icon/IconAssignmentTurnedIn';
import IconAutorenew from '../../../../../../Icon/IconAutorenew';
import IconBackup from '../../../../../../Icon/IconBackup';
import IconBook from '../../../../../../Icon/IconBook';
import IconBookmark from '../../../../../../Icon/IconBookmark';
import IconBookmarkBorder from '../../../../../../Icon/IconBookmarkBorder';
import IconBugReport from '../../../../../../Icon/IconBugReport';
import IconBuild from '../../../../../../Icon/IconBuild';
import IconCached from '../../../../../../Icon/IconCached';
import IconCameraEnhance from '../../../../../../Icon/IconCameraEnhance';
import IconCardGiftcard from '../../../../../../Icon/IconCardGiftcard';
import IconCardMembership from '../../../../../../Icon/IconCardMembership';
import IconCardTravel from '../../../../../../Icon/IconCardTravel';
import IconChangeHistory from '../../../../../../Icon/IconChangeHistory';
import IconCheckCircle from '../../../../../../Icon/IconCheckCircle';
import IconChromeReaderMode from '../../../../../../Icon/IconChromeReaderMode';
import IconClass from '../../../../../../Icon/IconClass';
import IconCode from '../../../../../../Icon/IconCode';
import IconCompareArrows from '../../../../../../Icon/IconCompareArrows';
import IconCopyright from '../../../../../../Icon/IconCopyright';
import IconCreditCard from '../../../../../../Icon/IconCreditCard';
import IconDashboard from '../../../../../../Icon/IconDashboard';
import IconDateRange from '../../../../../../Icon/IconDateRange';
import IconDelete from '../../../../../../Icon/IconDelete';
import IconDeleteForever from '../../../../../../Icon/IconDeleteForever';
import IconDescription from '../../../../../../Icon/IconDescription';
import IconDns from '../../../../../../Icon/IconDns';
import IconDone from '../../../../../../Icon/IconDone';
import IconDoneAll from '../../../../../../Icon/IconDoneAll';
import IconDonutLarge from '../../../../../../Icon/IconDonutLarge';
import IconDonutSmall from '../../../../../../Icon/IconDonutSmall';
import IconEject from '../../../../../../Icon/IconEject';
import IconEuroSymbol from '../../../../../../Icon/IconEuroSymbol';
import IconEvent from '../../../../../../Icon/IconEvent';
import IconEventSeat from '../../../../../../Icon/IconEventSeat';
import IconExitToApp from '../../../../../../Icon/IconExitToApp';
import IconExplore from '../../../../../../Icon/IconExplore';
import IconExtension from '../../../../../../Icon/IconExtension';
import IconFace from '../../../../../../Icon/IconFace';
import IconFavorite from '../../../../../../Icon/IconFavorite';
import IconFavoriteBorder from '../../../../../../Icon/IconFavoriteBorder';
import IconFeedback from '../../../../../../Icon/IconFeedback';
import IconFindInPage from '../../../../../../Icon/IconFindInPage';
import IconFindReplace from '../../../../../../Icon/IconFindReplace';
import IconFingerprint from '../../../../../../Icon/IconFingerprint';
import IconFlightLand from '../../../../../../Icon/IconFlightLand';
import IconFlightTakeoff from '../../../../../../Icon/IconFlightTakeoff';
import IconFlipToBack from '../../../../../../Icon/IconFlipToBack';
import IconFlipToFront from '../../../../../../Icon/IconFlipToFront';
import IconGTranslate from '../../../../../../Icon/IconGTranslate';
import IconGavel from '../../../../../../Icon/IconGavel';
import IconGetApp from '../../../../../../Icon/IconGetApp';
import IconGif from '../../../../../../Icon/IconGif';
import IconGrade from '../../../../../../Icon/IconGrade';
import IconGroupWork from '../../../../../../Icon/IconGroupWork';
import IconHelp from '../../../../../../Icon/IconHelp';
import IconHelpOutline from '../../../../../../Icon/IconHelpOutline';
import IconHighlightOff from '../../../../../../Icon/IconHighlightOff';
import IconHistory from '../../../../../../Icon/IconHistory';
import IconHome from '../../../../../../Icon/IconHome';
import IconHourglassEmpty from '../../../../../../Icon/IconHourglassEmpty';
import IconHourglassFull from '../../../../../../Icon/IconHourglassFull';
import IconHttp from '../../../../../../Icon/IconHttp';
import IconHttps from '../../../../../../Icon/IconHttps';
import IconImportantDevices from '../../../../../../Icon/IconImportantDevices';
import IconInfo from '../../../../../../Icon/IconInfo';
import IconInfoOutline from '../../../../../../Icon/IconInfoOutline';
import IconInput from '../../../../../../Icon/IconInput';
import IconInvertColors from '../../../../../../Icon/IconInvertColors';
import IconLabel from '../../../../../../Icon/IconLabel';
import IconLabelOutline from '../../../../../../Icon/IconLabelOutline';
import IconLanguage from '../../../../../../Icon/IconLanguage';
import IconLaunch from '../../../../../../Icon/IconLaunch';
import IconLightbulbOutline from '../../../../../../Icon/IconLightbulbOutline';
import IconLineStyle from '../../../../../../Icon/IconLineStyle';
import IconLineWeight from '../../../../../../Icon/IconLineWeight';
import IconList from '../../../../../../Icon/IconList';
import IconLock from '../../../../../../Icon/IconLock';
import IconLockOpen from '../../../../../../Icon/IconLockOpen';
import IconLockOutline from '../../../../../../Icon/IconLockOutline';
import IconLoyalty from '../../../../../../Icon/IconLoyalty';
import IconMarkunreadMailbox from '../../../../../../Icon/IconMarkunreadMailbox';
import IconMotorcycle from '../../../../../../Icon/IconMotorcycle';
import IconNoteAdd from '../../../../../../Icon/IconNoteAdd';
import IconOfflinePin from '../../../../../../Icon/IconOfflinePin';
import IconOpacity from '../../../../../../Icon/IconOpacity';
import IconOpenInBrowser from '../../../../../../Icon/IconOpenInBrowser';
import IconOpenInNew from '../../../../../../Icon/IconOpenInNew';
import IconOpenWith from '../../../../../../Icon/IconOpenWith';
import IconPageview from '../../../../../../Icon/IconPageview';
import IconPanTool from '../../../../../../Icon/IconPanTool';
import IconPayment from '../../../../../../Icon/IconPayment';
import IconPermCameraMic from '../../../../../../Icon/IconPermCameraMic';
import IconPermContactCalendar from '../../../../../../Icon/IconPermContactCalendar';
import IconPermDataSetting from '../../../../../../Icon/IconPermDataSetting';
import IconPermDeviceInformation from '../../../../../../Icon/IconPermDeviceInformation';
import IconPermIdentity from '../../../../../../Icon/IconPermIdentity';
import IconPermMedia from '../../../../../../Icon/IconPermMedia';
import IconPermPhoneMsg from '../../../../../../Icon/IconPermPhoneMsg';
import IconPermScanWifi from '../../../../../../Icon/IconPermScanWifi';
import IconPets from '../../../../../../Icon/IconPets';
import IconPictureInPicture from '../../../../../../Icon/IconPictureInPicture';
import IconPictureInPictureAlt from '../../../../../../Icon/IconPictureInPictureAlt';
import IconPlayForWork from '../../../../../../Icon/IconPlayForWork';
import IconPolymer from '../../../../../../Icon/IconPolymer';
import IconPowerSettingsNew from '../../../../../../Icon/IconPowerSettingsNew';
import IconPregnantWoman from '../../../../../../Icon/IconPregnantWoman';
import IconPrint from '../../../../../../Icon/IconPrint';
import IconQueryBuilder from '../../../../../../Icon/IconQueryBuilder';
import IconQuestionAnswer from '../../../../../../Icon/IconQuestionAnswer';
import IconReceipt from '../../../../../../Icon/IconReceipt';
import IconRecordVoiceOver from '../../../../../../Icon/IconRecordVoiceOver';
import IconRedeem from '../../../../../../Icon/IconRedeem';
import IconRemoveShoppingCart from '../../../../../../Icon/IconRemoveShoppingCart';
import IconReorder from '../../../../../../Icon/IconReorder';
import IconReportProblem from '../../../../../../Icon/IconReportProblem';
import IconRestore from '../../../../../../Icon/IconRestore';
import IconRestorePage from '../../../../../../Icon/IconRestorePage';
import IconRoom from '../../../../../../Icon/IconRoom';
import IconRoundedCorner from '../../../../../../Icon/IconRoundedCorner';
import IconRowing from '../../../../../../Icon/IconRowing';
import IconSchedule from '../../../../../../Icon/IconSchedule';
import IconSearch from '../../../../../../Icon/IconSearch';
import IconSettings from '../../../../../../Icon/IconSettings';
import IconSettingsApplications from '../../../../../../Icon/IconSettingsApplications';
import IconSettingsBackupRestore from '../../../../../../Icon/IconSettingsBackupRestore';
import IconSettingsBluetooth from '../../../../../../Icon/IconSettingsBluetooth';
import IconSettingsBrightness from '../../../../../../Icon/IconSettingsBrightness';
import IconSettingsCell from '../../../../../../Icon/IconSettingsCell';
import IconSettingsEthernet from '../../../../../../Icon/IconSettingsEthernet';
import IconSettingsInputAntenna from '../../../../../../Icon/IconSettingsInputAntenna';
import IconSettingsInputComponent from '../../../../../../Icon/IconSettingsInputComponent';
import IconSettingsInputComposite from '../../../../../../Icon/IconSettingsInputComposite';
import IconSettingsInputHdmi from '../../../../../../Icon/IconSettingsInputHdmi';
import IconSettingsInputSvideo from '../../../../../../Icon/IconSettingsInputSvideo';
import IconSettingsOverscan from '../../../../../../Icon/IconSettingsOverscan';
import IconSettingsPhone from '../../../../../../Icon/IconSettingsPhone';
import IconSettingsPower from '../../../../../../Icon/IconSettingsPower';
import IconSettingsRemote from '../../../../../../Icon/IconSettingsRemote';
import IconSettingsVoice from '../../../../../../Icon/IconSettingsVoice';
import IconShop from '../../../../../../Icon/IconShop';
import IconShopTwo from '../../../../../../Icon/IconShopTwo';
import IconShoppingBasket from '../../../../../../Icon/IconShoppingBasket';
import IconShoppingCart from '../../../../../../Icon/IconShoppingCart';
import IconSpeakerNotes from '../../../../../../Icon/IconSpeakerNotes';
import IconSpeakerNotesOff from '../../../../../../Icon/IconSpeakerNotesOff';
import IconSpellcheck from '../../../../../../Icon/IconSpellcheck';
import IconStars from '../../../../../../Icon/IconStars';
import IconStore from '../../../../../../Icon/IconStore';
import IconSubject from '../../../../../../Icon/IconSubject';
import IconSupervisorAccount from '../../../../../../Icon/IconSupervisorAccount';
import IconSwapHoriz from '../../../../../../Icon/IconSwapHoriz';
import IconSwapVert from '../../../../../../Icon/IconSwapVert';
import IconSwapVerticalCircle from '../../../../../../Icon/IconSwapVerticalCircle';
import IconSystemUpdateAlt from '../../../../../../Icon/IconSystemUpdateAlt';
import IconTab from '../../../../../../Icon/IconTab';
import IconTabUnselected from '../../../../../../Icon/IconTabUnselected';
import IconTheaters from '../../../../../../Icon/IconTheaters';
import IconThumbDown from '../../../../../../Icon/IconThumbDown';
import IconThumbUp from '../../../../../../Icon/IconThumbUp';
import IconThumbsUpDown from '../../../../../../Icon/IconThumbsUpDown';
import IconTimeline from '../../../../../../Icon/IconTimeline';
import IconToc from '../../../../../../Icon/IconToc';
import IconToday from '../../../../../../Icon/IconToday';
import IconToll from '../../../../../../Icon/IconToll';
import IconTouchApp from '../../../../../../Icon/IconTouchApp';
import IconTrackChanges from '../../../../../../Icon/IconTrackChanges';
import IconTranslate from '../../../../../../Icon/IconTranslate';
import IconTrendingDown from '../../../../../../Icon/IconTrendingDown';
import IconTrendingFlat from '../../../../../../Icon/IconTrendingFlat';
import IconTrendingUp from '../../../../../../Icon/IconTrendingUp';
import IconTurnedIn from '../../../../../../Icon/IconTurnedIn';
import IconTurnedInNot from '../../../../../../Icon/IconTurnedInNot';
import IconUpdate from '../../../../../../Icon/IconUpdate';
import IconVerifiedUser from '../../../../../../Icon/IconVerifiedUser';
import IconViewAgenda from '../../../../../../Icon/IconViewAgenda';
import IconViewArray from '../../../../../../Icon/IconViewArray';
import IconViewCarousel from '../../../../../../Icon/IconViewCarousel';
import IconViewColumn from '../../../../../../Icon/IconViewColumn';
import IconViewDay from '../../../../../../Icon/IconViewDay';
import IconViewHeadline from '../../../../../../Icon/IconViewHeadline';
import IconViewList from '../../../../../../Icon/IconViewList';
import IconViewModule from '../../../../../../Icon/IconViewModule';
import IconViewQuilt from '../../../../../../Icon/IconViewQuilt';
import IconViewStream from '../../../../../../Icon/IconViewStream';
import IconViewWeek from '../../../../../../Icon/IconViewWeek';
import IconVisibility from '../../../../../../Icon/IconVisibility';
import IconVisibilityOff from '../../../../../../Icon/IconVisibilityOff';
import IconWatchLater from '../../../../../../Icon/IconWatchLater';
import IconWork from '../../../../../../Icon/IconWork';
import IconYoutubeSearchedFor from '../../../../../../Icon/IconYoutubeSearchedFor';
import IconZoomIn from '../../../../../../Icon/IconZoomIn';
import IconZoomOut from '../../../../../../Icon/IconZoomOut';

export default function ActionIcons() {
  return (
    <div>
      <CategoryHeader>action</CategoryHeader>
      <FigContainer>
        <Figure tabIndex={0}>
          <Icon3DRotation size="32"/>
          <FigCaption>
            Icon3DRotation
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAccessibility size="32"/>
          <FigCaption>
            IconAccessibility
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAccessible size="32"/>
          <FigCaption>
            IconAccessible
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAccountBalance size="32"/>
          <FigCaption>
            IconAccountBalance
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAccountBalanceWallet size="32"/>
          <FigCaption>
            IconAccountBalanceWallet
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAccountBox size="32"/>
          <FigCaption>
            IconAccountBox
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAccountCircle size="32"/>
          <FigCaption>
            IconAccountCircle
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAddShoppingCart size="32"/>
          <FigCaption>
            IconAddShoppingCart
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAlarm size="32"/>
          <FigCaption>
            IconAlarm
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAlarmAdd size="32"/>
          <FigCaption>
            IconAlarmAdd
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAlarmOff size="32"/>
          <FigCaption>
            IconAlarmOff
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAlarmOn size="32"/>
          <FigCaption>
            IconAlarmOn
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAllOut size="32"/>
          <FigCaption>
            IconAllOut
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAndroid size="32"/>
          <FigCaption>
            IconAndroid
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAnnouncement size="32"/>
          <FigCaption>
            IconAnnouncement
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAspectRatio size="32"/>
          <FigCaption>
            IconAspectRatio
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAssessment size="32"/>
          <FigCaption>
            IconAssessment
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAssignment size="32"/>
          <FigCaption>
            IconAssignment
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAssignmentInd size="32"/>
          <FigCaption>
            IconAssignmentInd
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAssignmentLate size="32"/>
          <FigCaption>
            IconAssignmentLate
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAssignmentReturn size="32"/>
          <FigCaption>
            IconAssignmentReturn
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAssignmentReturned size="32"/>
          <FigCaption>
            IconAssignmentReturned
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAssignmentTurnedIn size="32"/>
          <FigCaption>
            IconAssignmentTurnedIn
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAutorenew size="32"/>
          <FigCaption>
            IconAutorenew
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBackup size="32"/>
          <FigCaption>
            IconBackup
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBook size="32"/>
          <FigCaption>
            IconBook
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBookmark size="32"/>
          <FigCaption>
            IconBookmark
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBookmarkBorder size="32"/>
          <FigCaption>
            IconBookmarkBorder
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBugReport size="32"/>
          <FigCaption>
            IconBugReport
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBuild size="32"/>
          <FigCaption>
            IconBuild
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCached size="32"/>
          <FigCaption>
            IconCached
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCameraEnhance size="32"/>
          <FigCaption>
            IconCameraEnhance
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCardGiftcard size="32"/>
          <FigCaption>
            IconCardGiftcard
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCardMembership size="32"/>
          <FigCaption>
            IconCardMembership
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCardTravel size="32"/>
          <FigCaption>
            IconCardTravel
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconChangeHistory size="32"/>
          <FigCaption>
            IconChangeHistory
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCheckCircle size="32"/>
          <FigCaption>
            IconCheckCircle
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconChromeReaderMode size="32"/>
          <FigCaption>
            IconChromeReaderMode
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconClass size="32"/>
          <FigCaption>
            IconClass
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCode size="32"/>
          <FigCaption>
            IconCode
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCompareArrows size="32"/>
          <FigCaption>
            IconCompareArrows
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCopyright size="32"/>
          <FigCaption>
            IconCopyright
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCreditCard size="32"/>
          <FigCaption>
            IconCreditCard
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDashboard size="32"/>
          <FigCaption>
            IconDashboard
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDateRange size="32"/>
          <FigCaption>
            IconDateRange
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDelete size="32"/>
          <FigCaption>
            IconDelete
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDeleteForever size="32"/>
          <FigCaption>
            IconDeleteForever
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDescription size="32"/>
          <FigCaption>
            IconDescription
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDns size="32"/>
          <FigCaption>
            IconDns
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDone size="32"/>
          <FigCaption>
            IconDone
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDoneAll size="32"/>
          <FigCaption>
            IconDoneAll
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDonutLarge size="32"/>
          <FigCaption>
            IconDonutLarge
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDonutSmall size="32"/>
          <FigCaption>
            IconDonutSmall
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconEject size="32"/>
          <FigCaption>
            IconEject
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconEuroSymbol size="32"/>
          <FigCaption>
            IconEuroSymbol
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconEvent size="32"/>
          <FigCaption>
            IconEvent
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconEventSeat size="32"/>
          <FigCaption>
            IconEventSeat
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconExitToApp size="32"/>
          <FigCaption>
            IconExitToApp
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconExplore size="32"/>
          <FigCaption>
            IconExplore
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconExtension size="32"/>
          <FigCaption>
            IconExtension
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFace size="32"/>
          <FigCaption>
            IconFace
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFavorite size="32"/>
          <FigCaption>
            IconFavorite
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFavoriteBorder size="32"/>
          <FigCaption>
            IconFavoriteBorder
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFeedback size="32"/>
          <FigCaption>
            IconFeedback
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFindInPage size="32"/>
          <FigCaption>
            IconFindInPage
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFindReplace size="32"/>
          <FigCaption>
            IconFindReplace
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFingerprint size="32"/>
          <FigCaption>
            IconFingerprint
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFlightLand size="32"/>
          <FigCaption>
            IconFlightLand
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFlightTakeoff size="32"/>
          <FigCaption>
            IconFlightTakeoff
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFlipToBack size="32"/>
          <FigCaption>
            IconFlipToBack
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFlipToFront size="32"/>
          <FigCaption>
            IconFlipToFront
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconGTranslate size="32"/>
          <FigCaption>
            IconGTranslate
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconGavel size="32"/>
          <FigCaption>
            IconGavel
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconGetApp size="32"/>
          <FigCaption>
            IconGetApp
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconGif size="32"/>
          <FigCaption>
            IconGif
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconGrade size="32"/>
          <FigCaption>
            IconGrade
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconGroupWork size="32"/>
          <FigCaption>
            IconGroupWork
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconHelp size="32"/>
          <FigCaption>
            IconHelp
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconHelpOutline size="32"/>
          <FigCaption>
            IconHelpOutline
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconHighlightOff size="32"/>
          <FigCaption>
            IconHighlightOff
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconHistory size="32"/>
          <FigCaption>
            IconHistory
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconHome size="32"/>
          <FigCaption>
            IconHome
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconHourglassEmpty size="32"/>
          <FigCaption>
            IconHourglassEmpty
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconHourglassFull size="32"/>
          <FigCaption>
            IconHourglassFull
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconHttp size="32"/>
          <FigCaption>
            IconHttp
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconHttps size="32"/>
          <FigCaption>
            IconHttps
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconImportantDevices size="32"/>
          <FigCaption>
            IconImportantDevices
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconInfo size="32"/>
          <FigCaption>
            IconInfo
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconInfoOutline size="32"/>
          <FigCaption>
            IconInfoOutline
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconInput size="32"/>
          <FigCaption>
            IconInput
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconInvertColors size="32"/>
          <FigCaption>
            IconInvertColors
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLabel size="32"/>
          <FigCaption>
            IconLabel
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLabelOutline size="32"/>
          <FigCaption>
            IconLabelOutline
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLanguage size="32"/>
          <FigCaption>
            IconLanguage
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLaunch size="32"/>
          <FigCaption>
            IconLaunch
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLightbulbOutline size="32"/>
          <FigCaption>
            IconLightbulbOutline
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLineStyle size="32"/>
          <FigCaption>
            IconLineStyle
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLineWeight size="32"/>
          <FigCaption>
            IconLineWeight
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconList size="32"/>
          <FigCaption>
            IconList
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLock size="32"/>
          <FigCaption>
            IconLock
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLockOpen size="32"/>
          <FigCaption>
            IconLockOpen
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLockOutline size="32"/>
          <FigCaption>
            IconLockOutline
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLoyalty size="32"/>
          <FigCaption>
            IconLoyalty
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMarkunreadMailbox size="32"/>
          <FigCaption>
            IconMarkunreadMailbox
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMotorcycle size="32"/>
          <FigCaption>
            IconMotorcycle
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconNoteAdd size="32"/>
          <FigCaption>
            IconNoteAdd
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconOfflinePin size="32"/>
          <FigCaption>
            IconOfflinePin
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconOpacity size="32"/>
          <FigCaption>
            IconOpacity
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconOpenInBrowser size="32"/>
          <FigCaption>
            IconOpenInBrowser
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconOpenInNew size="32"/>
          <FigCaption>
            IconOpenInNew
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconOpenWith size="32"/>
          <FigCaption>
            IconOpenWith
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPageview size="32"/>
          <FigCaption>
            IconPageview
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPanTool size="32"/>
          <FigCaption>
            IconPanTool
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPayment size="32"/>
          <FigCaption>
            IconPayment
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPermCameraMic size="32"/>
          <FigCaption>
            IconPermCameraMic
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPermContactCalendar size="32"/>
          <FigCaption>
            IconPermContactCalendar
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPermDataSetting size="32"/>
          <FigCaption>
            IconPermDataSetting
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPermDeviceInformation size="32"/>
          <FigCaption>
            IconPermDeviceInformation
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPermIdentity size="32"/>
          <FigCaption>
            IconPermIdentity
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPermMedia size="32"/>
          <FigCaption>
            IconPermMedia
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPermPhoneMsg size="32"/>
          <FigCaption>
            IconPermPhoneMsg
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPermScanWifi size="32"/>
          <FigCaption>
            IconPermScanWifi
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPets size="32"/>
          <FigCaption>
            IconPets
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPictureInPicture size="32"/>
          <FigCaption>
            IconPictureInPicture
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPictureInPictureAlt size="32"/>
          <FigCaption>
            IconPictureInPictureAlt
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPlayForWork size="32"/>
          <FigCaption>
            IconPlayForWork
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPolymer size="32"/>
          <FigCaption>
            IconPolymer
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPowerSettingsNew size="32"/>
          <FigCaption>
            IconPowerSettingsNew
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPregnantWoman size="32"/>
          <FigCaption>
            IconPregnantWoman
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPrint size="32"/>
          <FigCaption>
            IconPrint
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconQueryBuilder size="32"/>
          <FigCaption>
            IconQueryBuilder
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconQuestionAnswer size="32"/>
          <FigCaption>
            IconQuestionAnswer
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconReceipt size="32"/>
          <FigCaption>
            IconReceipt
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRecordVoiceOver size="32"/>
          <FigCaption>
            IconRecordVoiceOver
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRedeem size="32"/>
          <FigCaption>
            IconRedeem
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRemoveShoppingCart size="32"/>
          <FigCaption>
            IconRemoveShoppingCart
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconReorder size="32"/>
          <FigCaption>
            IconReorder
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconReportProblem size="32"/>
          <FigCaption>
            IconReportProblem
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRestore size="32"/>
          <FigCaption>
            IconRestore
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRestorePage size="32"/>
          <FigCaption>
            IconRestorePage
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRoom size="32"/>
          <FigCaption>
            IconRoom
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRoundedCorner size="32"/>
          <FigCaption>
            IconRoundedCorner
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRowing size="32"/>
          <FigCaption>
            IconRowing
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSchedule size="32"/>
          <FigCaption>
            IconSchedule
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSearch size="32"/>
          <FigCaption>
            IconSearch
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSettings size="32"/>
          <FigCaption>
            IconSettings
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSettingsApplications size="32"/>
          <FigCaption>
            IconSettingsApplications
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSettingsBackupRestore size="32"/>
          <FigCaption>
            IconSettingsBackupRestore
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSettingsBluetooth size="32"/>
          <FigCaption>
            IconSettingsBluetooth
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSettingsBrightness size="32"/>
          <FigCaption>
            IconSettingsBrightness
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSettingsCell size="32"/>
          <FigCaption>
            IconSettingsCell
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSettingsEthernet size="32"/>
          <FigCaption>
            IconSettingsEthernet
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSettingsInputAntenna size="32"/>
          <FigCaption>
            IconSettingsInputAntenna
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSettingsInputComponent size="32"/>
          <FigCaption>
            IconSettingsInputComponent
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSettingsInputComposite size="32"/>
          <FigCaption>
            IconSettingsInputComposite
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSettingsInputHdmi size="32"/>
          <FigCaption>
            IconSettingsInputHdmi
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSettingsInputSvideo size="32"/>
          <FigCaption>
            IconSettingsInputSvideo
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSettingsOverscan size="32"/>
          <FigCaption>
            IconSettingsOverscan
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSettingsPhone size="32"/>
          <FigCaption>
            IconSettingsPhone
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSettingsPower size="32"/>
          <FigCaption>
            IconSettingsPower
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSettingsRemote size="32"/>
          <FigCaption>
            IconSettingsRemote
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSettingsVoice size="32"/>
          <FigCaption>
            IconSettingsVoice
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconShop size="32"/>
          <FigCaption>
            IconShop
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconShopTwo size="32"/>
          <FigCaption>
            IconShopTwo
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconShoppingBasket size="32"/>
          <FigCaption>
            IconShoppingBasket
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconShoppingCart size="32"/>
          <FigCaption>
            IconShoppingCart
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSpeakerNotes size="32"/>
          <FigCaption>
            IconSpeakerNotes
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSpeakerNotesOff size="32"/>
          <FigCaption>
            IconSpeakerNotesOff
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSpellcheck size="32"/>
          <FigCaption>
            IconSpellcheck
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconStars size="32"/>
          <FigCaption>
            IconStars
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconStore size="32"/>
          <FigCaption>
            IconStore
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSubject size="32"/>
          <FigCaption>
            IconSubject
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSupervisorAccount size="32"/>
          <FigCaption>
            IconSupervisorAccount
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSwapHoriz size="32"/>
          <FigCaption>
            IconSwapHoriz
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSwapVert size="32"/>
          <FigCaption>
            IconSwapVert
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSwapVerticalCircle size="32"/>
          <FigCaption>
            IconSwapVerticalCircle
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSystemUpdateAlt size="32"/>
          <FigCaption>
            IconSystemUpdateAlt
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTab size="32"/>
          <FigCaption>
            IconTab
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTabUnselected size="32"/>
          <FigCaption>
            IconTabUnselected
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTheaters size="32"/>
          <FigCaption>
            IconTheaters
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconThumbDown size="32"/>
          <FigCaption>
            IconThumbDown
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconThumbUp size="32"/>
          <FigCaption>
            IconThumbUp
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconThumbsUpDown size="32"/>
          <FigCaption>
            IconThumbsUpDown
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTimeline size="32"/>
          <FigCaption>
            IconTimeline
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconToc size="32"/>
          <FigCaption>
            IconToc
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconToday size="32"/>
          <FigCaption>
            IconToday
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconToll size="32"/>
          <FigCaption>
            IconToll
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTouchApp size="32"/>
          <FigCaption>
            IconTouchApp
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTrackChanges size="32"/>
          <FigCaption>
            IconTrackChanges
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTranslate size="32"/>
          <FigCaption>
            IconTranslate
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTrendingDown size="32"/>
          <FigCaption>
            IconTrendingDown
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTrendingFlat size="32"/>
          <FigCaption>
            IconTrendingFlat
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTrendingUp size="32"/>
          <FigCaption>
            IconTrendingUp
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTurnedIn size="32"/>
          <FigCaption>
            IconTurnedIn
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTurnedInNot size="32"/>
          <FigCaption>
            IconTurnedInNot
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconUpdate size="32"/>
          <FigCaption>
            IconUpdate
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconVerifiedUser size="32"/>
          <FigCaption>
            IconVerifiedUser
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconViewAgenda size="32"/>
          <FigCaption>
            IconViewAgenda
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconViewArray size="32"/>
          <FigCaption>
            IconViewArray
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconViewCarousel size="32"/>
          <FigCaption>
            IconViewCarousel
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconViewColumn size="32"/>
          <FigCaption>
            IconViewColumn
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconViewDay size="32"/>
          <FigCaption>
            IconViewDay
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconViewHeadline size="32"/>
          <FigCaption>
            IconViewHeadline
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconViewList size="32"/>
          <FigCaption>
            IconViewList
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconViewModule size="32"/>
          <FigCaption>
            IconViewModule
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconViewQuilt size="32"/>
          <FigCaption>
            IconViewQuilt
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconViewStream size="32"/>
          <FigCaption>
            IconViewStream
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconViewWeek size="32"/>
          <FigCaption>
            IconViewWeek
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconVisibility size="32"/>
          <FigCaption>
            IconVisibility
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconVisibilityOff size="32"/>
          <FigCaption>
            IconVisibilityOff
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconWatchLater size="32"/>
          <FigCaption>
            IconWatchLater
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconWork size="32"/>
          <FigCaption>
            IconWork
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconYoutubeSearchedFor size="32"/>
          <FigCaption>
            IconYoutubeSearchedFor
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconZoomIn size="32"/>
          <FigCaption>
            IconZoomIn
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconZoomOut size="32"/>
          <FigCaption>
            IconZoomOut
          </FigCaption>
        </Figure>
      </FigContainer>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/website/app/demos/Icon/components/categories/ActionIcons.js